<template>
    <input type="text" v-model="displayValue" @blur="onBlur" @focus="isInputActive = true"></input>
</template>

<script>
export default {
    props: ['value', 'nullable'],
    data() {
        return {
            isInputActive: false,
            tempValue: null,
            emitChange: false
        }
    },
    computed: {
        displayValue: {
            get() {
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return this.value.toString()
                } else {
                    // User is not modifying now. Format display value for user interface (with commas and '$')
                    return '$' + this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,').replace(/[.]00$/, '')
                }
            },
            set(modifiedValue) {
                this.emitChange = true;
                // Recalculate value after ignoring non-number chars in user input
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.\-]/g, ''))
                if ( isNaN(newValue) && this.nullable !== "true" ) {
                    newValue = 0
                } else if ( isNaN(newValue) && this.nullable == "true" ) {
                  newValue = null;
                }
                this.$emit('input', newValue);
                this.tempValue = newValue;
            }
        }
    },
    methods: {
      onBlur() {
        this.isInputActive = false;

        if(this.tempValue !== null && this.emitChange) {
          this.$emit('change', this.tempValue);
          this.tempValue = null;
        } else if (this.nullable == "true" && this.emitChange) {
          this.$emit('change', this.tempValue);
        }
        this.emitChange = false;
      }
    }
}
</script>

<style lang="scss">
input {
    &:hover {
        cursor: pointer;

        &:disabled {
            cursor: not-allowed;
        }
    }
    &:focus {
        cursor: text;
    }
}
</style>
